<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            
            <h4 class="page-title">System Logs Management</h4>
        </div>

    </div>
</div>


<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">

                            <diV class="row">
                                <div class="col-sm-12 col-md-8">
                                </div>
                                
                             
                            </diV>


                            <div>
                                <div>
                                    <mat-form-field>

                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table
                                        [dataSource]="dataSource" matSort style=" margin-top: 30px;">
                                        <ng-container matColumnDef="adminId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Admin Id</th>
                                            <td *matCellDef="let row" style="padding-left: 14px;">
                                                {{row.adminId}}
                                                
                                                </td>
                                        </ng-container>
                                        <ng-container matColumnDef="login">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Login Date And Time</th>
                                            <td *matCellDef="let row">{{row.login| date}}  {{row.login| date : 'HH:mm'}} </td>
                                        </ng-container>
                                        <ng-container matColumnDef="loggedDevice">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Logged Device</th>
                                            <td *matCellDef="let row"> {{row.loggedDevice}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="loggedBrowser">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Logged Browser</th>
                                            <td *matCellDef="let row">{{row.loggedBrowser}}</td>
                                        </ng-container>
                                        <ng-container matColumnDef="logout">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Logout Date & Time</th>
                                            <td *matCellDef="let row"> {{row.logout| date}}  {{row.logout| date : 'HH:mm'}} </td>
                                        </ng-container>

                                      
                                
                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>

                        </div>
                    </div>
                    <mat-paginator [length]="500" [pageSize]="5" [pageSizeOptions]="[5, 10, 25,500]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- ============================================================== -->